/**
 * Collection Scroll Position Memory
 * Remembers scroll position when navigating to a product page,
 * restores it when the user clicks the back button.
 */
(function() {
  var STORAGE_KEY = 'gc-scroll-pos';
  var STORAGE_URL_KEY = 'gc-scroll-url';

  function isCollectionPage() {
    return window.location.pathname.indexOf('/collections/') === 0 
      && window.location.pathname.indexOf('/products/') === -1;
  }

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') > -1;
  }

  function saveScrollPosition() {
    if (!isCollectionPage()) return;

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        y: window.scrollY || document.documentElement.scrollTop,
        path: window.location.pathname + window.location.search,
        time: Date.now()
      }));
      sessionStorage.setItem(STORAGE_URL_KEY, window.location.href);
    } catch (e) {
      // sessionStorage unavailable
    }
  }

  function restoreScrollPosition() {
    if (!isCollectionPage()) return;

    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;

      var data = JSON.parse(raw);
      var currentPath = window.location.pathname + window.location.search;

      // Only restore if returning to the same collection page
      // and if saved within the last 30 minutes
      if (data.path === currentPath && (Date.now() - data.time) < 1800000) {
        // Use requestAnimationFrame to ensure DOM is ready
        requestAnimationFrame(function() {
          // Small delay to allow lazy-loaded content to render
          setTimeout(function() {
            window.scrollTo(0, data.y);
          }, 100);
        });
      }

      // Clear after restoring
      sessionStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_URL_KEY);
    } catch (e) {
      // sessionStorage unavailable
    }
  }

  // Save scroll position when clicking any product link on a collection page
  if (isCollectionPage()) {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      if (href.indexOf('/products/') > -1) {
        saveScrollPosition();
      }
    });
  }

  // Restore on page load (covers both bfcache and fresh loads)
  if (isCollectionPage()) {
    // For bfcache restoration
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) {
        restoreScrollPosition();
      }
    });

    // For regular back-button navigation (non-bfcache)
    var navType = performance.getEntriesByType && performance.getEntriesByType('navigation');
    if (navType && navType.length && navType[0].type === 'back_forward') {
      restoreScrollPosition();
    }
    // Fallback for older browsers
    else if (window.performance && window.performance.navigation && 
             window.performance.navigation.type === 2) {
      restoreScrollPosition();
    }
  }
})();
